import apiClient from "../api/apiClient";
import API_CONFIG from '../config/api.js';

const API_URL = API_CONFIG.apiUrl("/brands");

const getAll = async (companyId = null) => {
  try {
    const params = companyId ? { company_id: companyId } : {};
    return await apiClient.get(API_URL, { params });
  } catch (error) {
    console.error("Erreur lors du getAll():", error);
    throw error;
  }
};

const create = async (data) => {
  try {
    return await apiClient.post(API_URL, data);
  } catch (error) {
    console.error("Erreur lors du create():", error);
    throw error;
  }
};

const update = async (id, data) => {
  try {
    return await apiClient.put(`${API_URL}/${id}`, data);
  } catch (error) {
    console.error("Erreur lors du update():", error);
    throw error;
  }
};

const deleteBrand = async (id) => {
  try {
    return await apiClient.delete(`${API_URL}/${id}`);
  } catch (error) {
    console.error("Erreur lors du deleteBrand():", error);
    throw error;
  }
};

export default {
  getAll,
  create,
  update,
  delete: deleteBrand,
};
